import React, { useContext } from 'react';

import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { DATABASE_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName';
import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component';

import type { ContentPrerequisitesProps } from './ContentPrerequisites';
import { ContentPrerequisites } from './ContentPrerequisites';

type DatabasePrerequisitesProps = Pick<
	ContentPrerequisitesProps,
	'children' | 'contentQueryResult' | 'route'
>;

export const DatabasePrerequisites = ({
	children,
	contentQueryResult,
	route,
}: DatabasePrerequisitesProps) => {
	const experienceTracker = useContext(ExperienceTrackerContext);

	const handleUnexpectedError = (error: Error) => {
		experienceTracker.fail({
			name: DATABASE_EXPERIENCE,
			error,
		});
		getMonitoringClient().submitError(error, {
			attribution: Attribution.CONTENT_TYPES,
		});
		markErrorAsHandled(error);
	};

	return (
		<ContentPrerequisites
			route={route}
			contentQueryResult={contentQueryResult}
			passThroughOnLoading
			handleUnexpectedError={handleUnexpectedError}
		>
			{children}
		</ContentPrerequisites>
	);
};
